'use strict';
module.exports = require('../../full/set');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/features/set/index.js
// module id = 1235
// module chunks = 0